package org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetAppConfig(
    @SerialName("cashRegisterGlobal")
    val cashRegisterGlobal: CashRegisterGlobal?,
    @SerialName("__typename")
    val typename: String?
)